module.exports = __webpack_public_path__ + "static/media/20ECE13.116e4b11.jpg";